import antdLocale from 'antd/es/locale/ru_RU';

export const antdCustomLocale = {
  ...antdLocale,
  Pagination: {
    ...antdLocale.Pagination,
    items_per_page: '', // Убираем "/ стр."
  },
};
